import { Link } from "react-router-dom";
import { LOGO_URL, NAV_LINKS, CONTACT, KEY_TOWNS } from "../../lib/site";

export default function Footer() {
  return (
    <footer
      className="bg-neutral-950 text-neutral-200 mt-24"
      data-testid="site-footer"
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="md:col-span-4">
            <div className="flex items-center gap-3">
              <img
                src={LOGO_URL}
                alt="Bittern Property Services"
                className="h-14 w-auto object-contain bg-white p-1"
              />
              <div className="leading-none">
                <div className="font-serif-display text-2xl tracking-wide">
                  BITTERN
                </div>
                <div className="text-[10px] tracking-[0.28em] text-neutral-400 mt-1">
                  PROPERTY SERVICES
                </div>
              </div>
            </div>
            <p className="mt-6 text-sm leading-relaxed text-neutral-400 max-w-sm">
              Restoring, maintaining and protecting homes across Norfolk with
              care, resilience and strong local roots.
            </p>
            <p className="mt-6 text-[11px] tracking-[0.22em] uppercase text-neutral-500">
              10% of profits · Norfolk wildlife conservation
            </p>
          </div>

          {/* Navigate */}
          <div className="md:col-span-3">
            <p className="overline text-neutral-500 mb-5">Navigate</p>
            <ul className="space-y-3 text-sm">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-neutral-300 hover:text-white transition-colors"
                    data-testid={`footer-nav-${l.to.replace(/\//g, "") || "home"}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <p className="overline text-neutral-500 mb-5">Contact</p>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={`tel:${CONTACT.phoneRaw}`}
                  className="hover:text-white text-neutral-300"
                  data-testid="footer-phone"
                >
                  {CONTACT.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${CONTACT.email}`}
                  className="hover:text-white text-neutral-300 break-all"
                  data-testid="footer-email"
                >
                  {CONTACT.email}
                </a>
              </li>
              <li className="text-neutral-400 pt-2">Mon – Sat · 07:30 – 18:00</li>
            </ul>
          </div>

          {/* Coverage */}
          <div className="md:col-span-2">
            <p className="overline text-neutral-500 mb-5">Coverage</p>
            <p className="text-sm text-neutral-300 leading-relaxed">
              All across Norfolk, plus parts of Cambridgeshire &amp;
              Lincolnshire.
            </p>
            <p className="mt-4 text-[11px] text-neutral-500 leading-relaxed">
              {KEY_TOWNS.slice(0, 6).join(" · ")}
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-[11px] text-neutral-500">
          <p>© {new Date().getFullYear()} Bittern Property Services. All rights reserved.</p>
          <p className="tracking-[0.22em] uppercase">Rooted in Norfolk · Built to last</p>
        </div>
      </div>
    </footer>
  );
}
